/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Columns1Inputs */

const en_datagrid_columns1 = /** @type {(inputs: Datagrid_Columns1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns`)
};

/**
* | output |
* | --- |
* | "Columns" |
*
* @param {Datagrid_Columns1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_columns1 = /** @type {((inputs?: Datagrid_Columns1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Columns1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_columns1(inputs)
});
export { datagrid_columns1 as "dataGrid_columns" }